import httpService from "../_utils/http-service";
import { traceEvent } from "../_utils/analytics-utils";
import { getHttpConfig } from "../_utils/auth-utils";

export const getDeliveryDirectory = (restaurantID, callback) => {
    return function(dispatch) {
      traceEvent("delivery", "get data");
      const url = `/restaurants/${restaurantID}/delivery/directory`;
      httpService.get(url, getHttpConfig()).then(res => {
        const restaurant = res.data.data;
        callback(res);
      });
    };
  };
